const Specific = ({children}) => {
    return (<div>

        {children}

    </div>);
}

export default Specific;